import { select } from 'redux-saga/effects';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import { formatDate } from '../utils/dateHelper.js';
import { selectTeamEvents, selectUserId } from '../selectors/general.js';
dayjs.extend(customParseFormat);

export function* canCreateEventByDateRange(start, end, eventId) {
    const teamEvents = yield select(selectTeamEvents);
    const userId = yield select(selectUserId);
    const duration = dayjs(end).diff(start, 'day');
    let date = dayjs(start);
    let i = 0;
    do {
        const formattedDate = formatDate(date);
        if (Object.prototype.hasOwnProperty.call(teamEvents, formattedDate)) {
            const myEvents = teamEvents[formattedDate].filter((e) => e.UserId === userId);
            if (eventId && myEvents.length && myEvents.find((myEvent) => myEvent.id !== eventId)) {
                throw new Error(`You already have event on ${formattedDate}.`);
            }
        }
        i++;
        date = date.add(1, 'day');
    } while (i <= duration);
}

export function* canCreateEventByDate(date, id) {
    const teamEvents = yield select(({ calendar }) => calendar.teamEvents);
    const formattedDate = formatDate(date);
    const userId = yield select(({ user }) => user.user.id);
    if (Object.prototype.hasOwnProperty.call(teamEvents, formattedDate)) {
        const myEvents = teamEvents[formattedDate].filter((e) => e.UserId === userId);
        if (id && myEvents.length && myEvents.find((myEvent) => myEvent.id !== id)) {
            throw new Error(`You already have event on ${formattedDate}.`);
        }
    }
}
